module.exports = __webpack_public_path__ + "static/media/Screenshot_20200405-175454_XSell_Restart.6edf5207.jpg";